import { useEffect, Component } from "react";
import Lenis from "lenis";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Projects from "@/components/Projects";
import Founder from "@/components/Founder";
import Values from "@/components/Values";
import Footer from "@/components/Footer";
import MobileCta from "@/components/MobileCta";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    return this.state.hasError ? null : this.props.children;
  }
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
    return () => lenis.destroy();
  }, []);

  return (
    <ErrorBoundary>
      <div className="grain relative min-h-screen overflow-x-clip bg-ink text-paper">
        <div className="pointer-events-none absolute inset-0 z-0">
          <div className="absolute -top-40 left-[8%] h-[34rem] w-[34rem] rounded-full bg-brand/25 blur-[140px]" />
          <div className="absolute right-[-10%] top-[35%] h-[28rem] w-[28rem] rounded-full bg-brand-neon/15 blur-[130px]" />
          <div className="absolute bottom-0 left-[30%] h-[26rem] w-[26rem] rounded-full bg-brand-deep/20 blur-[130px]" />
        </div>
        <div className="relative z-10">
          <Nav />
          <main>
            <Hero />
            <Marquee />
            <Services />
            <Projects />
            <Founder />
            <Values />
          </main>
          <Footer />
          <MobileCta />
        </div>
      </div>
    </ErrorBoundary>
  );
}

export default App;
